import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_449: DocMigration = {
  maxSchemaVersion: "0.0.449",
  description: "Gable openings renamed to roof openings",
  apply(json: any): any {
    // Get gable openings
    const { gableOpenings = {} } = json;

    // Convert gable openings to roof openings
    const roofOpenings = Object.values(gableOpenings).reduce(
      (acc: { [key: string]: any }, gableOpening: any) => {
        acc[gableOpening.id] = {
          ...gableOpening,
          entityType: "ROOF_OPENING",
        };
        return acc;
      },
      {} as { [key: string]: any },
    );

    // Delete gable openings
    delete json.gableOpenings;

    // Add roof openings to the doc
    return {
      ...json,
      roofOpenings,
    };
  },
};

export default migration_0_0_449;
